<button
    [matBadge]="count"
    [matBadgeHidden]="count === 0"
    mat-stroked-button
    class="riege-button"
    (click)="showFilter()"
    aria-label="Show filter"
    i18n-aria-label="@@aria-label-filter">
    <mat-icon [ngClass]="{ 'riege-icon': true, 'reset-margin--all': isMobile() || isTablet() }">tune</mat-icon>
    <span i18n="@@button-label-filter" *ngIf="!isMobile() && !isTablet()">Filter</span>
</button>
